// One list of annotation kinds: the tooltip badge, the legend and the colours all read it.
export const ANNOTATION_TYPES = [
  { type: 'needs_review', i18nKey: 'needsReview', className: 'type-needs-review' },
  { type: 'mark_note', i18nKey: 'markNote', className: 'type-mark-note' },
  { type: 'glossary', i18nKey: 'glossary', className: 'type-glossary' },
  { type: 'proper_noun', i18nKey: 'properNoun', className: 'type-proper-noun' },
  { type: 'preservation', i18nKey: 'preservation', className: 'type-preservation' },
  { type: 'critic_fix', i18nKey: 'criticFix', className: 'type-critic-fix' },
  { type: 'consistency', i18nKey: 'consistency', className: 'type-consistency' },
];

export const ANNOTATION_TYPE_BY_KEY = Object.fromEntries(ANNOTATION_TYPES.map((a) => [a.type, a]));
